"use client";

import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@postcheesy/core-utils";

/**
 * @todo Refining paragraph element @elliot-alexandre
 * Add more variants and size
 */

const paragraphVariants = cva("", {
  variants: {
    variant: {
      default: "",
      background: "",
      medium: "font-medium",
      foreground: "text-background",
      muted: "text-muted-foreground",
    },
    colors: {
      default: "",
      foreground: "text-background",
      muted: "text-muted-foreground",
      primary: "text-primary",
      secondary: "text-secondary",
      reversed: "text-primary-foreground",
    },
    size: {
      default: "text-lg",
      xs: "text-xs",
      sm: "text-sm",
      base: "text-base",
      lg: "text-lg",
      xl: "text-xl",
    },
  },
  defaultVariants: {
    variant: "default",
    colors: "default",
    size: "default",
  },
});

export interface ParagraphProps
  extends React.HTMLAttributes<HTMLParagraphElement>,
    VariantProps<typeof paragraphVariants> {}

const Paragraph = React.forwardRef<HTMLParagraphElement, ParagraphProps>(
  ({ className, variant, colors, size, ...props }, ref) => {
    return (
      <p
        className={cn(paragraphVariants({ variant, colors, size, className }))}
        ref={ref}
        {...props}
      />
    );
  },
);
Paragraph.displayName = "Paragraph";

export { Paragraph, paragraphVariants };
